export default {
  props: ['id'],
  data() {
    return {
      docID: this.$props.id,
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    doc() {
      console.log(this.$store.state.news.doc);
      return this.$store.state.news.doc;
    },
  },
  methods: {
  },
  created() {
  },
};
